import ModuleSection from '../ModuleSection';
import Candidates from './Candidates';
import { CANDIDATES } from '../../lib/buildCandidates';
import { resolveSectionProps, useSectionText } from '../../lib/useSectionText';

const DEFAULTS = {
  number: '05',
  kicker: "Who's Running",
  title: (
    <>
      The 2026 <em>Field</em>
    </>
  ),
  intro: `${CANDIDATES.length} candidates so far for the 2026 general election. Search by name, narrow by party, or pick a district to see who's contesting it. Not all candidates have officially announced and party lists are still being updated, so errors or omissions may exist.`,
};

export default function CandidatesModule() {
  const row = useSectionText('candidates');
  const props = resolveSectionProps(DEFAULTS, row);
  return (
    <ModuleSection {...props} id="candidates">
      <Candidates />
    </ModuleSection>
  );
}
